import Loadable from 'react-loadable';

export const TransferApiDoc = Loadable({
  loader: () => import('./TransferApiDoc'),
  loading: () => null,
});


// WEBPACK FOOTER //
// ./src/containers/TransferApiDoc/index.ts